import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Fetches the favicon URL stored under the "favicon" slot in site_images
 * and injects/updates the <link rel="icon"> tags in <head>.
 * Falls back silently to whatever is already declared in index.html.
 */
export function useDynamicFavicon() {
  useEffect(() => {
    let cancelled = false;
    supabase
      .from("site_images")
      .select("url")
      .eq("slot", "favicon")
      .maybeSingle()
      .then(({ data }) => {
        if (cancelled || !data?.url) return;
        const url = data.url;
        const rels = ["icon", "shortcut icon", "apple-touch-icon"];
        rels.forEach((rel) => {
          let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
          if (!link) {
            link = document.createElement("link");
            link.rel = rel;
            document.head.appendChild(link);
          }
          link.href = url;
          link.type = "image/png";
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);
}